export default __webpack_public_path__ + "images/9E.4af72dc.png";